import { defineStore } from 'pinia';

import {
  AutocompleteRepository,
  AcquirerResponse,
} from '@/repositories/generated';

type AcquirerAutocompleteStoreState = {
  acquirers: AcquirerResponse[];
};

export const useAcquirerAutocompleteStore = defineStore('acquirerAutocomplete', {
  state: (): AcquirerAutocompleteStoreState => ({
    acquirers: [],
  }),
  actions: {
    async getAcquirers() {
      // 一度取得したらキャッシュから取得
      if (this.acquirers.length) {
        return this.acquirers;
      }

      const res = await AutocompleteRepository.searchAcquirer({
        term: undefined,
      });
      this.acquirers = res;
      return res;
    },
  },
});
